// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__1kCbt","header":"style_header__ebW1h"};